import 'select2';
import 'select2/dist/css/select2.css'; 
const pbdsFormLeads = {
    init: function () { 
        pbdsFormLeads.fixPlaceHolder('#phone');
        pbdsFormLeads.fixPlaceHolder('#cpf');

        $('.pbds-form--leads #state').select2();
        $('.pbds-form--leads #city').select2();
    },
    fixPlaceHolder: function(id)
    {
        var $input = $(id);
        if ($input.length >0)
        {
            var placeholderOriginal = $input.attr('data-placeholder');

            $input.on('focus', function() {
                $input.attr('placeholder', placeholderOriginal);
            });

            $input.on('blur', function() {
                $input.attr('placeholder', placeholderOriginal);
            });

            $input.on('change', function() {
                $input.attr('placeholder', placeholderOriginal);
            });

            setTimeout(function() {
                $input.attr('placeholder', placeholderOriginal);
            }, 2000);
        }
    }
}
// initialize component
window.loadedComponents.push({ component: 'pbds-form--leads', init: pbdsFormLeads.init});

export default() => {
    pbdsFormLeads.init();
}
